import { LoggedError, ServiceError } from "../../../../../services/errors";
import { SAVED_ITEMS_SDK_FAILURE } from "../../constants";
import { PERSISTENT_ERROR } from "../../../common/constants";
import { getSort, getSortOrder } from "../../selectors";
import requestRetryWrapper from "./requestRetryWrapper";
import requestProvider from "./requestProvider";

export const getSavedItems =
  ({ retryBackoffs, ...rest }) =>
  async (dispatch, getState) => {
    const state = getState();
    const sort = getSort(state);
    const sortOrder = getSortOrder(state);

    const onRetryFailure = () =>
      dispatch({
        type: PERSISTENT_ERROR,
        payload: {
          failedActionType: SAVED_ITEMS_SDK_FAILURE
        }
      });

    let response;
    try {
      const request = requestProvider({
        state,
        params: { sort, sortOrder, ...rest }
      });
      if (retryBackoffs.length) {
        response = await requestRetryWrapper(
          request,
          onRetryFailure,
          retryBackoffs.length + 1,
          retryBackoffs
        );
      } else {
        response = await request();
      }
    } catch (e) {
      if (e instanceof ServiceError) {
        throw e;
      }
      throw new LoggedError(e, LoggedError.error);
    }
    if (response === null) {
      return null;
    }

    const { ...savedItems } = response;

    return savedItems;
  };
